// Studio navigation, grouped the way people set an agent up: shape it, fence it,
// tune it, run it, test it. Labels resolve under AI_AGENT.STUDIO.
export const STUDIO_NAV_GROUPS = [
  {
    key: 'START',
    items: [
      {
        key: 'OVERVIEW',
        routeName: 'ai_agents_studio_overview',
        icon: 'i-lucide-layout-dashboard',
      },
    ],
  },
  {
    key: 'BUILD',
    items: [
      {
        key: 'PERSONA',
        routeName: 'ai_agents_studio_persona',
        icon: 'i-lucide-user-round',
      },
      {
        key: 'KNOWLEDGE',
        routeName: 'ai_agents_studio_knowledge',
        icon: 'i-lucide-book-open',
      },
    ],
  },
  {
    key: 'RULES',
    items: [
      {
        key: 'INTENT',
        routeName: 'ai_agents_studio_intent',
        icon: 'i-lucide-brain',
      },
      {
        key: 'TRANSFER',
        routeName: 'ai_agents_studio_transfer',
        icon: 'i-lucide-arrow-right-left',
      },
      {
        key: 'API_RULES',
        routeName: 'ai_agents_studio_api_rules',
        icon: 'i-lucide-webhook',
      },
    ],
  },
  {
    key: 'OPERATIONS',
    items: [
      {
        key: 'SAFETY',
        routeName: 'ai_agents_studio_safety',
        icon: 'i-lucide-shield-check',
      },
    ],
  },
  {
    key: 'TEST',
    items: [
      {
        key: 'PLAYGROUND',
        routeName: 'ai_agents_studio_playground',
        icon: 'i-lucide-flask-conical',
      },
    ],
  },
];

// The bare /studio route renders Overview.
// Pages that are no longer in the menu still highlight the item that replaced them.
const ROUTE_ALIASES = {
  ai_agents_studio: 'ai_agents_studio_overview',
  ai_agents_studio_badwords: 'ai_agents_studio_safety',
};

export const STUDIO_NAV_ITEMS = STUDIO_NAV_GROUPS.flatMap(group => group.items);

export const findNavItem = routeName => {
  const name = ROUTE_ALIASES[routeName] || routeName;
  return (
    STUDIO_NAV_ITEMS.find(item => item.routeName === name) ||
    STUDIO_NAV_ITEMS[0]
  );
};
